/* eslint-disable import/prefer-default-export */
export function getMetaTags(page) {
  let content;
  switch (page) {
    case '/':
      content = {
        descriptionContent:
          'Register now to get contacted by prospective employers, access exclusive tech jobs in cybersecurity, data science/business intelligence, digital marketing, software engineering & UI/UX Design and participate in career-related events & challenges.',
        keywordContent: 'Home page keys',
        titleContent:
          'TeSA Virtual Fair | Find opportunities with exciting employers',
        URL: `https://tesavirtualfair.snaphunt.com/`,
        image: 'https://images.snaphunt.com/assets/images/tesa-banner.jpg',
      };
      break;
    default:
      break;
  }
  return content;
}
